// Index file for the directory. Don't add anything else here.
import CarouselTransactionProcessComponents from './CarouselTransactionProcessComponents';
export default CarouselTransactionProcessComponents;
